export default __webpack_public_path__ + "static/media/check-green.ab64715b.svg";